export const testAgentConfig:any = {
    "placeholderText":"Add Global Execution Engine",
    "placeholderIcon":"",
    "iconType": 'assetImage'
   };

   export const tableTestAgentConfig:any = {
    "placeholderText":"Select Execution Engine",
    "placeholderIcon":"",
    "iconType": 'assetImage'
   };

export const versionConfig: any={
  "placeholderText":"Select Version",
};

   //remove testAgentSections
 export const  testAgentSections = [
    {
      "label":"Cloud Based Execution Engines",
      "options":[
        {
          "label":"Agent 1",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"1"
        },
        {
          "label":"Agent 8",
          "icon":"assets/images/agent/agent-dead.svg",
          "value":"8"
        },
        {
          "label":"Agent 2",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"2"
        },
        {
          "label":"Agent 3",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"3"
        },
        {
          "label":"Agent 4",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"4"
        },
        {
          "label":"Agent 5",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"5"
        },
        {
          "label":"Agent 6",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"6"
        },
        {
          "label":"Agent 7",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"7"
        },
      ]
    },{
      "label":"Local Execution Engines",
      "options":[
        {
          "label":"Agent 11",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"11"
        },
        {
          "label":"Agent 18",
          "icon":"assets/images/agent/agent-dead.svg",
          "value":"18"
        },
        {
          "label":"Agent 12",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"12"
        },
        {
          "label":"Agent 13",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"13"
        },
        {
          "label":"Agent 14",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"14"
        },
        {
          "label":"Agent 15",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"15"
        },
        {
          "label":"Agent 16",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"16"
        },
        {
          "label":"Agent 17",
          "icon":"assets/images/agent/agent-alive.svg",
          "value":"17"
        },
      ]
    }
   ];

   export const testBrowserConfig:any = {
    "placeholderText":"Add Global Browser",
    "placeholderIcon":"",
    "iconType": 'assetImage'
   }

   export const tableTestBrowserConfig:any = {
    "placeholderText":"Select Browser",
    "placeholderIcon":"",
    "iconType": 'assetImage'
   }

   export const testBrowserSections:any = [
    {
        "label":"",
        "options":[
          {
            "label":"Chrome",
            "icon":"",
            "value":"Chrome"
          },
          {
            "label":"Edge",
            "icon":"",
            "value":"Edge"
          },
          {
            "label":"Mozilla Firefox",
            "icon":"",
            "value":"Firefox"
          },
          {
            "label":"Operamini",
            "icon":"",
            "value":"Operamini"
          },
        ]
    }
   ];
  